const FormatEmail = (EmailSettings, ToAddress, invoiceNumber, CompanyName, TotalAmount, type) => {
    var EmailData = EmailSettings;
    var tmp = document.createElement("DIV");
    tmp.innerHTML = EmailData.Template;
    var content = tmp.textContent || tmp.innerText || "";

    content = content.replace("@@invoicenumber@@", invoiceNumber);
    content = content.replace(/@@companyname@@/g, CompanyName);
    content = content.replace(/@@totalAmount@@/g, TotalAmount);
    content = content.replace(/@@type@@/g, type);
    EmailData.To = ToAddress;
    EmailData.Template = content;
    EmailData.Subject = EmailData.Subject.replace("@@type@@", type);

    return EmailData;
};

export default FormatEmail;